import { Component } from 'preact';
import {
  GOLD, TEXT_PRIMARY, TEXT_BODY, TEXT_MUTED,
  DIALOG_STYLE, PANEL_BG, FourCorners,
} from '../lib/medievalTheme';
import { CloseButton } from './ui/navButtons';
import { pushDismiss, removeDismiss } from '../utils/escStack';
import MarkdownNotes from './MarkdownNotes';
import { t } from '../localization/t';

const NOTES_BOX_STYLE = {
  background: PANEL_BG,
  border: `1px solid ${GOLD} 0.12)`,
  borderRadius: 'var(--radius-lg)',
  color: TEXT_BODY,
};

/**
 * Read-only "what's new" popup, opened from the hub's version tag. Shows the
 * Player Notes for the version the player is currently running. The notes are
 * fetched by the caller and passed in; this component only renders the three
 * display states (loading / notes / nothing-to-show).
 *
 * Props:
 *   version. Running version string (no leading "v")
 *   notes. Markdown Player Notes, or null/empty when none exist
 *   loading. True while the caller is fetching
 *   onClose. Fired on close button / backdrop / Escape
 */
export default class ChangelogModal extends Component {
  componentDidMount() {
    this._escDismissId = pushDismiss(() => this.props.onClose?.());
  }

  componentWillUnmount() {
    removeDismiss(this._escDismissId);
  }

  renderBody() {
    const { notes, loading } = this.props;

    if (loading) {
      return (
        <div className="py-8 text-center text-sm" style={{ color: TEXT_MUTED }}>
          {t('Loading changelog…')}
        </div>
      );
    }
    if (notes) {
      return (
        <div
          className="max-h-[40cqh] overflow-y-auto px-4 py-3 text-sm leading-relaxed"
          style={NOTES_BOX_STYLE}
        >
          <MarkdownNotes text={notes} />
        </div>
      );
    }
    return (
      <div className="py-8 text-center text-sm" style={{ color: TEXT_MUTED }}>
        {t('No changelog available for this version.')}
      </div>
    );
  }

  render() {
    const { version, onClose } = this.props;

    return (
      <div
        className="fixed inset-0 z-[200] flex items-center justify-center"
        style={{ background: 'rgba(0,0,0,0.75)' }}
        onClick={onClose}
      >
        <div
          className="relative w-[34cqw] flex flex-col p-6 gap-4"
          style={DIALOG_STYLE}
          onClick={(e) => e.stopPropagation()}
        >
          <FourCorners />
          <CloseButton onClick={onClose} className="absolute top-3 right-3" />

          <div className="flex flex-col gap-1 pr-8">
            <h2
              className="arena-heading text-xl font-bold"
              style={{ color: TEXT_PRIMARY }}
            >
              {t("What's New")}
            </h2>
            <span
              className="text-[0.6875cqw] font-semibold tabular-nums"
              style={{ color: `${GOLD} 0.55)` }}
            >
              {version ? t('v{version} · Open Beta', { version }) : t('Open Beta')}
            </span>
          </div>

          {this.renderBody()}
        </div>
      </div>
    );
  }
}
